import React, { useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import { useGlobalContext } from "../../../Context/GlobalContext";

const createEntry = () => ({
  via: null,
  quota: null,
  restriction_by_name: null,
  commodity: null,
  wagons: null,
  wagon_type: null,
  fcn_no: null,
  order_date: null,
  order_time: null,
  restriction_remark: null,
  remarks: null,
  action: "pending",

  sidings: [
    {
      pick_drop_point: "",
      pick_drop_flag: "S",
    },
  ],

  destinations: [
    {
      pick_drop_point: "",
      pick_drop_flag: "D",
    },
  ],
});

const IndentInsertion = ({ siding, rakeType, commodity, destination }) => {
  const { userData } = useGlobalContext();

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [entries, setEntries] = useState([createEntry()]);

  const keys = [
    "Sr No.",
    "siding",
    "destination",
    "via",
    "quota",
    "restriction_by_name",
    "commodity",
    "wagons",
    "wagon_type",
    "fcn_no",
    "order_date",
    "order_time",
    "restriction_remark",
    "remarks",
    "action",
    "delete",
  ];

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) =>
        i === rowIndex
          ? {
              ...row,
              [key]: value,
            }
          : row,
      ),
    );
  };
  const addRow = () => {
    setEntries((prev) => [...prev, createEntry()]);
  };

  const removeRow = (index) => {
    setEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const addSiding = (entryIndex) => {
    const temp = [...entries];

    temp[entryIndex].sidings.push({
      pick_drop_point: "",
      pick_drop_flag: "S",
    });

    setEntries(temp);
  };

  const addDestination = (entryIndex) => {
    const temp = [...entries];

    temp[entryIndex].destinations.push({
      pick_drop_point: "",
      pick_drop_flag: "D",
    });

    setEntries(temp);
  };

  const removeSiding = (entryIndex, index) => {
    const temp = [...entries];

    temp[entryIndex].sidings = temp[entryIndex].sidings.filter(
      (_, i) => i !== index,
    );

    setEntries(temp);
  };

  const removeDestination = (entryIndex, index) => {
    const temp = [...entries];

    temp[entryIndex].destinations = temp[entryIndex].destinations.filter(
      (_, i) => i !== index,
    );

    setEntries(temp);
  };

  const handleSubmit = async () => {
    const payload = {
      hdr_table_name: "t_indent_hdr",
      dtl_table_name: "t_indent_dtls",
      foreign_key: "ind_id",

      data: entries.map((entry) => ({
        hdr_data: {
          commodity: entry.commodity,
          quota: entry.quota,
          via: entry.via,
          restriction_by_name: entry.restriction_by_name,
          wagons: entry.wagons,
          wagon_type: entry.wagon_type,
          fcn_no: entry.fcn_no,
          order_date: entry.order_date,
          order_time: entry.order_time,
          restriction_remark: entry.restriction_remark,
          remarks: entry.remarks,
          action: entry.action,
          created_by: userData.id,
        },

        dtl_data: [
          ...entry.sidings.filter((x) => x.pick_drop_point),

          ...entry.destinations.filter((x) => x.pick_drop_point),
        ],
      })),
    };
    try {
      const response = await fetch(`${urlPrefix}insert/multipleInsertData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok === false) {
        toast.error(result?.message || "Upload failed");
      } else {
        toast.success("Data uploaded successfully");
        setEntries([createEntry()]);
      }
    } catch (err) {
      toast.error("Upload failed");
      console.error(err);
    }
  };
  const inputStyle = {
    width: "110px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const selectStyle = {
    width: "110px",
    backgroundColor: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    paddingRight: "2rem",
  };
  return (
    <div className="container-fluid mt-3">
      <h4 className="bg-dark text-white p-2 text-center">CLS Indent </h4>

      <button className="btn btn-dark mb-3" onClick={addRow}>
        Add Row
      </button>
      <div className="table-responsive">
        <table className="table table-bordered" style={{ fontSize: "12px" }}>
          <thead>
            <tr className="table-dark">
              {keys.map((key) => (
                <th key={key}>{key.replaceAll("_", " ").toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody className="border p-3 bg-light border-dark border-4 ">
            {entries.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                {/* <tr>
                {" "}
                <div className="d-flex justify-content-center gap-2 mb-3">
                  <h1 class="badge text-bg-dark p-2">{rowIndex + 1}</h1>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => removeRow(rowIndex)}
                  >
                    &times;
                  </button>
                </div>
              </tr> */}
                {/* <tr className="table-dark">
                {keys.map((key) => (
                  <th key={key}>{key.replaceAll("_", " ")}</th>
                ))}
              </tr> */}
                <tr>
                  {keys.map((key) => (
                    <td key={key}>
                      {key === "siding" ? (
                        row.sidings.map((item, idx) => (
                          <div
                            key={idx}
                            className="d-flex mb-2 "
                            style={{ width: "120px" }}
                          >
                            <select
                              className="form-select form-select-sm shadow"
                              style={selectStyle}
                              value={item.pick_drop_point}
                              onChange={(e) => {
                                const temp = [...entries];
                                temp[rowIndex].sidings[idx].pick_drop_point =
                                  e.target.value;
                                setEntries(temp);
                              }}
                            >
                              <option value="">Select</option>
                              {siding.map((s, i) => (
                                <option key={i} value={s}>
                                  {s}
                                </option>
                              ))}
                            </select>

                            {/* <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeSiding(rowIndex, idx)}
                          >
                            &times;
                          </button> */}
                          </div>
                        ))
                      ) : key === "destination" ? (
                        <div className="row " style={{ width: "320px" }}>
                          {row.destinations.map((item, idx) => (
                            <div
                              key={idx}
                              className=" "
                              style={{ maxWidth: "130px" }}
                            >
                              <div className="d-flex mb-2  ">
                                <select
                                  className="form-select form-select-sm shadow"
                                  style={selectStyle}
                                  value={item.pick_drop_point}
                                  onChange={(e) => {
                                    const temp = [...entries];
                                    temp[rowIndex].destinations[
                                      idx
                                    ].pick_drop_point = e.target.value;
                                    setEntries(temp);
                                  }}
                                >
                                  <option value="">Select</option>
                                  {destination.map((s, i) => (
                                    <option key={i} value={s}>
                                      {s}
                                    </option>
                                  ))}
                                </select>

                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() =>
                                    removeDestination(rowIndex, idx)
                                  }
                                >
                                  &times;
                                </button>
                              </div>
                            </div>
                          ))}
                          <div style={{ maxWidth: "20px" }}>
                            <button
                              className="btn btn-success btn-sm "
                              onClick={() => addDestination(rowIndex)}
                            >
                              <TiPlus />
                            </button>
                          </div>
                        </div>
                      ) : key === "Sr No." ? (
                        <h1 class="badge text-bg-dark p-2">{rowIndex + 1}</h1>
                      ) : key === "delete" ? (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => removeRow(rowIndex)}
                        >
                          &times;
                        </button>
                      ) : // : key === "add destination" ? (
                      //   <button
                      //     className="btn btn-success btn-sm"
                      //     onClick={() => addDestination(rowIndex)}
                      //   >
                      //     <TiPlus />
                      //   </button>
                      // )
                      // : key === "add siding" ? (
                      //   <button
                      //     className="btn btn-success btn-sm"
                      //     onClick={() => addSiding(rowIndex)}
                      //   >
                      //     <TiPlus />
                      //   </button>
                      // )
                      key === "order_time" ? (
                        <input
                          type="time"
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          value={row[key] ? row[key] : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "order_date" ? (
                        <input
                          type="date"
                          className=" form-select-sm shadow"
                          style={inputStyle}
                          value={row[key] ? row[key] : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "fcn_no" || key === "wagons" ? (
                        <input
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          type="number"
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : //  : key === "action" ? (
                      //   <input
                      //     disabled
                      //     type="text"
                      //     value={"pending"}
                      //     onChange={(e) =>
                      //       handleChange(rowIndex, key, e.target.value)
                      //     }
                      //   />
                      // )
                      key === "commodity" ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={selectStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          {commodity.map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      ) : key === "wagon_type" ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={selectStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          {rakeType.map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      ) : key === "action" ? (
                        <select
                          className="form-select form-select-sm shadow"
                          style={selectStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          <option value={"pending"}>{"pending"}</option>{" "}
                          <option value={"due"}>{"due"}</option>
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-select form-select-sm shadow"
                          style={inputStyle}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {entries.every((entry) =>
        entry.sidings.every((siding) => siding.pick_drop_point.length > 0),
      ) && (
        <div className="text-center">
          <button className="btn btn-success" onClick={handleSubmit}>
            Upload
          </button>
        </div>
      )}
    </div>
  );
};

export default IndentInsertion;
